/**
 * AvatarDisplay — Reusable avatar display component
 * IDENTITY:P2.D
 *
 * Renders circular avatar image with gold border or letter-badge fallback.
 * Props: avatarUrl, size (24|48|128), fallbackLetter, fallbackColor, showBorder
 */

import React, { useState } from 'react';

const SIZES = {
  24: { container: 'w-6 h-6', text: 'text-xs', border: 'border' },
  48: { container: 'w-12 h-12', text: 'text-lg', border: 'border' },
  128: { container: 'w-32 h-32', text: 'text-4xl', border: 'border-2' },
};

export default function AvatarDisplay({
  avatarUrl,
  size = 48,
  fallbackLetter = '?',
  fallbackColor = '#3B1D5E',
  showBorder = true,
}) {
  const [imgError, setImgError] = useState(false);
  const sizeClasses = SIZES[size] || SIZES[48];
  const showFallback = !avatarUrl || imgError;

  const borderClass = showBorder
    ? `${sizeClasses.border} border-[#D4A03C]`
    : '';

  if (showFallback) {
    return (
      <div
        className={`${sizeClasses.container} rounded-full flex items-center justify-center ${borderClass}`}
        style={{ backgroundColor: fallbackColor }}
        role="img"
        aria-label={`Avatar fallback: ${fallbackLetter}`}
      >
        <span className={`${sizeClasses.text} font-bold text-white`}>
          {fallbackLetter}
        </span>
      </div>
    );
  }

  return (
    <img
      src={avatarUrl}
      alt="User avatar"
      className={`${sizeClasses.container} rounded-full object-cover ${borderClass}`}
      onError={() => setImgError(true)}
      loading="lazy"
    />
  );
}
